const contactMe ={
  
    linkedIn :"https://www.linkedin.com/in/tahrer-abu-diab-93927512b/",
    email :"tahrer_ad@outlook.com",
    gitHub :"https://github.com/tahrer007/saving-box",
    tel : "0524513424" 

}


export {contactMe} ; 